import "./divider.css";

function Divider(props) {
	return <hr className="divider"></hr>;
}

export default Divider;
